// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__11jZB","inner":"Footer_inner__2NoVs","nextIcon":"Footer_nextIcon__23a2e","innerLeft":"Footer_innerLeft__3b4Lg"};